import { Option, Schema as S } from "effect";
import { Field } from "foldkit/fieldValidation";

import { apiData } from "../../api/asyncData";
import {
	AttributeSchemaList,
	EntityType,
	ValueType,
} from "../../api/schemas/attributeSchema";

export const Form = S.Struct({
	/** `Some(id)` while editing an existing entry. */
	editingId: S.Option(S.String),
	entityType: EntityType,
	key: Field(S.String),
	valueType: ValueType,
	label: S.String,
	description: S.String,
	subType: S.String,
	sortOrder: S.Number,
	/** v1's single `error` string: a rule failure or a failed save. */
	error: S.Option(S.String),
});
export type Form = typeof Form.Type;

export const emptyForm: Form = {
	editingId: Option.none(),
	entityType: "record",
	key: { _tag: "NotValidated", value: "" },
	valueType: "string",
	label: "",
	description: "",
	subType: "",
	sortOrder: 0,
	error: Option.none(),
};

export const Model = S.Struct({
	page: S.Literal("AttributeSchemaSettings"),
	schema: apiData(AttributeSchemaList).schema,
	/** `Some` while the form is open. */
	form: S.Option(Form),
	saving: S.Boolean,
});
export type Model = typeof Model.Type;
